// import React from "react";
// import HeaderInner from "../../Components/HeaderInner";
// import Textheader from "../../Components/Textheader";
// import Clientinfo from "../../Components/Clientinfo";
// import Post1 from "../../assets/images/Spa/Post-3.png";
// import Gif from "../../assets/images/add-to-cart.gif";

// function SATOrderPlaced() {
//   return (
//     <>
//       <HeaderInner />
//       <main className="bg-white back-white pad-top-0 spa-order-placed">
//         <div className="img-pnl">
//           <img src={Gif} alt="Place Order" />
//         </div>
//         <h2 className="order-placed">Your Booking is Confirmed</h2>
//         <Clientinfo className={"spa"} />

//         <div className="full-heading grey-bg flex">
//           <h2 className="blck co-header">Order Details</h2>
//         </div>
//         <div className="full-div padd-div">
//           <div className="booking-order-detail">
//             <div className="img-pnl">
//               <img src={Post1} alt="Spa" />
//             </div>
//             <div className="txt-pnl">
//               <p>REVIVING JOURNEY</p>
//               <h3>AED 545.00</h3>
//             </div>
//           </div>
//         </div>
//         <div className="spacer-40"></div>
//         <div className="full-div padd-div text-center">
//           <a className="reg-btn large" href="/HomeMenu/qr-code">
//             {" "}
//             Back to Home
//           </a>
//         </div>
//       </main>
//     </>
//   );
// }
// export default SATOrderPlaced;

import React, { useContext } from "react";
import HeaderInner from "../../Components/HeaderInner";
import Textheader from "../../Components/Textheader";
import Clientinfo from "../../Components/Clientinfo";
import Post1 from "../../assets/images/Spa/Post-3.png";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Gif from "../../assets/images/add-to-cart.gif";
import NewFooter from "../../NewFooter";
import Title from "../../new-components/title/Title";
import "../../new-pages/hotel-services/HotelServices.scss";
import { ThemeContext } from "../../context/ThemeContext";
import Sar from "../../assets/images/icons/Sar";

function SATOrderPlaced() {
  const currency = localStorage.getItem("currency");

  const { t, i18n } = useTranslation();
  const location = useLocation();
  const rawPath = location.pathname;
  const room_uuid = rawPath.split("/")[1];
  const salon = location.state.salon;
  const {
    room_name,
    ordered_at,
    order_number,
    total,
    salon_order,
    payment_methods,
    orderNumber,
    paymentMethodText,
    total_price,
    price,
    servises,
    salonAtHomeOrder,
    order,
  } = location.state?.metadata;
  const datameta = location.state?.metadata;

  // const theme = location.state?.theme;
  // const new_design = localStorage.getItem("new_design");
  // const theme = new_design == "true";
  const { theme } = useContext(ThemeContext);
  console.log("location.state?.metadata", location.state?.theme);
  const formatOrderedAt = (orderedAt) => {
    if (!orderedAt) return "";
    const date = new Date(orderedAt);
    const formatted = date.toLocaleString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });

    return formatted.replace("am", "am").replace("pm", "pm");
  };
  return (
    <div className={theme ? "food" : ""}>
      {theme ? <Title title={""} /> : <HeaderInner headerName={""} />}
      <main className="bg-white back-white pad-top-0 spa-order-placed">
        <div className="img-pnl">
          <img src={Gif} alt="Place Order" />
        </div>
        <h2 className="order-placed">{t("We have received your Request")}!</h2>
        <Clientinfo
          className={"spa"}
          roomNumber={room_name}
          orderNumber={order_number}
          orderedAt={formatOrderedAt(ordered_at)}
        />

        <div className="full-heading grey-bg flex">
          <h2 className="blck co-header">{t("Order Details")} </h2>
        </div>
        <div className="full-div padd-div">
          {/* {salon ? (
            <div className="booking-order-detail">
              <div className="img-pnl">
                <img
                  src={
                    salonAtHomeOrder?.image || datameta?.salonAtHomeOrder?.image
                  }
                  alt="Spa"
                />
              </div>
              <div className="txt-pnl">
                <p>
                  {salonAtHomeOrder?.name || datameta?.salonAtHomeOrder?.name}
                </p>
                <h3>
                  {total_price != 0 && (
                    <>
                      {currency === "SAR" ? (
                        <>
                          <Sar color="currentColor" />
                          {""}
                        </>
                      ) : (
                        `${currency} `
                      )}
                      <span style={{ marginLeft: "2px" }}>{total_price}</span>
                    </>
                  )}
                </h3>
              </div>
            </div>
          ) : order ? (
            <div className="booking-order-detail">
              <div className="img-pnl">
                <img
                  src={order.image || datameta?.salonAtHomeOrder?.image}
                  alt="Spa"
                />
              </div>
              <div className="txt-pnl">
                <p>{order.name}</p>
                <h3> </h3>
              </div>
            </div>
          ) : (
            <div className="booking-order-detail">
              <div className="img-pnl">
                <img
                  src={servises?.image || datameta?.salonAtHomeOrder?.image}
                  alt="Spa"
                />
              </div>
              <div className="txt-pnl">
                <p>{servises?.name || datameta?.salonAtHomeOrder?.name}</p>
                <h3>
                  {currency === "SAR" ? (
                    <>
                      <Sar color="currentcolor" />
                    </>
                  ) : (
                    `${currency} `
                  )}{" "}
                  {price || datameta?.total_price}
                </h3>
              </div>
            </div>
          )} */}

          {/* <div className="booking-order-detail">
            <div className="img-pnl">
              <img src={Post1} alt="Spa" />
            </div>
            <div className="txt-pnl">
              <p>REVIVING JOURNEY</p>
            </div>
          </div> */}
        </div>
        <div className="full-div padd-div">
          <div className="booking-order-detail">
            <div className="img-pnl">
              <img src={Post1} alt="Spa" />
            </div>
            <div className="txt-pnl">
              <div className="d-flex flex-column ">
                <p className="m-0">{salon_order?.service?.name} </p>
                <span style={{ fontSize: "12px" }}>
                  {salon_order?.salon_name}
                </span>
              </div>
              <h3>
                {salon_order?.currency === "SAR" ? (
                  <Sar color="currentcolor" />
                ) : (
                  `${salon_order?.currency || currency || "AED"} `
                )}
                {total}
              </h3>
            </div>
          </div>
        </div>
        <div className="spacer-40"></div>
        <div className="full-div padd-div text-center">
          <Link className="reg-btn big" to={`/${room_uuid}/qr-code`}>
            {" "}
            {t("Back to Home")}
          </Link>
        </div>
      </main>
      {theme && <NewFooter />}
    </div>
  );
}
export default SATOrderPlaced;
